import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandWidthSideSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 3h4v10h-4v-2h2V5h-2V3Z" />
  </svg>
);
export default IconExpandWidthSideSizeS;
